import { useEffect, useState } from "react"
import { Appointment } from "../../../pages/platform/components/Appointment"
import { getAppointmentsByUserEmail } from "../../../utils/apis/booking-service"
import { useAuth } from "../../../utils/context/AuthContext"
import { handleDaysDifference, handleHoursDifference, handleMinutesDifference } from "../../../utils/Functions"

export const useGetAppointmentsByEmail = (patientEmail: string | null) => {
    const { auth } = useAuth()
    const idToken = auth.idToken

    const [appointments, setAppointments] = useState<Appointment[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<Error | null>(null)

    useEffect(() => {
        if (!patientEmail || !idToken) {
            setIsLoading(false)
            return
        }
        const fetchAppointments = async () => {
            try {
                getAppointmentsByUserEmail(
                    idToken,
                    patientEmail,
                    (appointments) => {
                        console.log("Appointments fetched correctly");
                        const allAppointments: Appointment[] = appointments.map((appointment) => ({
                            date: appointment.payload.scheduled_event.start_time,
                            patientName: appointment.payload.name,
                            patientEmail: appointment.email,
                            editUrl: appointment.payload.reschedule_url,
                            connectUrl: appointment.payload.scheduled_event.location.join_url,
                            cancelUrl: appointment.payload.cancel_url,
                            remainingDays: handleDaysDifference(appointment.payload.scheduled_event.start_time),
                            remainingHours: handleHoursDifference(appointment.payload.scheduled_event.start_time),
                            remainingMinutes: handleMinutesDifference(appointment.payload.scheduled_event.start_time),
                            status: appointment.payload.status,
                            expert_email: appointment.organizer_email,
                        }));
                        setAppointments(allAppointments)
                    },
                    (error) => {
                        console.log(error)
                    }
                )
            } catch (err: any) {
                setError(err)
            } finally {
                setIsLoading(false)
            }
        }

        fetchAppointments()
    }, [patientEmail, idToken])

    return { appointments, isLoading, error }
}